import React from 'react';
import { Country } from '../../../utils/ContextProviders/appContextTypes';
import { Friend } from '../../../utils/ContextProviders/friendContextTypes';
import { FormState } from '../accountFormTypes';
import { validatePassword } from './passwordValidation';

const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

const usFlag = '&#127482;&#127480;';
export const usPhoneMask = '+1 (111) 111-1111';

export function isPhoneNumberValid(phoneNumber: string, countryCode: string): boolean {
  if (countryCode === 'GB') {
    return phoneNumber.length === 12;
  }
  return phoneNumber.length === 11;
}

export const isValidEmail = (email: string): boolean => {
  // temporary check for .con as invalid
  if (email.endsWith('.con')) {
    return false;
  }
  return EMAIL_REGEX.test(email);
};

export function returnOnlyNumbers(string: string): string {
  return string && string.replace(/\D/g, '');
}

export function getPhoneNumberPrefixFromMask(maskString: string) {
  if (!maskString) {
    return '';
  }
  return maskString.split(' ')[0];
}

export function sortCountries(countries: Country[]) {
  return countries.sort((x, y) => {
    if (x.countryCode === 'US') {
      return -1;
    }
    if (x.displayName < y.displayName) {
      return 0;
    }
    return 1;
  });
}

export function buildCountryOptions(countries: Country[] | []) {
  if (countries.length) {
    const options = sortCountries(countries).map((country: Country) => {
      const {
        displayName, flagUrl, phoneFormat, countryCode,
      } = country;
      // eslint-disable-next-line react/no-danger
      return (<option aria-label={displayName} key={displayName} dangerouslySetInnerHTML={{ __html: `${flagUrl || ''} &nbsp;${displayName} ${getPhoneNumberPrefixFromMask(phoneFormat)}` }} data-phone-mask={phoneFormat} value={countryCode} />);
    });

    return options;
  }
  // eslint-disable-next-line react/no-danger
  return (<option aria-label="United States" dangerouslySetInnerHTML={{ __html: `${usFlag} &nbsp;United States +1` }} data-phone-mask={usPhoneMask} value="US" />);
}

export function convertMaskForInputMask(maskString: string | undefined) {
  if (!maskString) {
    return usPhoneMask;
  }

  const maskStringWithSlash = `${maskString[0]}\\${maskString.slice(1, maskString.length)}`;
  return maskStringWithSlash.replace(/0/g, '1');
}

export function validateAccountForm(formState: FormState, friend: Friend) {
  const {
    firstName, lastName, email, password, phoneNumber,
  } = formState;
  const { countryCode, isEmailUnique, isPhoneNumberUnique } = friend;
  if (firstName.length === 0 || lastName.length === 0) {
    return false;
  }
  if (!isValidEmail(email)) {
    return false;
  }
  if (!validatePassword(password)) {
    return false;
  }
  if (!isPhoneNumberValid(returnOnlyNumbers(phoneNumber), countryCode)) {
    return false;
  }
  if (!isEmailUnique || !isPhoneNumberUnique) {
    return false;
  }
  return true;
}
